"use client";

import { useUser } from "@clerk/nextjs";
import { useEffect, useState } from "react";
import { getAnonymousSessionId, clearAnonymousSession, hasAnonymousSession } from "@/lib/anonymousSession";
import HistoryMigratedModal from "@/components/HistoryMigratedModal";

export default function UserMigrationHandler() {
  const { isSignedIn, user, isLoaded } = useUser();
  const [showMigrationModal, setShowMigrationModal] = useState(false);
  const [migratedCount, setMigratedCount] = useState(0);
  const [hasCheckedMigration, setHasCheckedMigration] = useState(false);

  // 회원가입 완료 감지 및 이력 마이그레이션 — 외부 인증 상태 + fetch 동기화, JCG-2034 마이그레이션 예정
  useEffect(() => {
    if (isLoaded && isSignedIn && user && !hasCheckedMigration) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setHasCheckedMigration(true);
      
      const migrateHistory = async () => {
        try {
          // 익명 세션이 존재하는 경우에만 마이그레이션 진행
          // hasAnonymousSession()은 세션 ID를 생성하지 않고 존재 여부만 확인
          if (!hasAnonymousSession()) {
            // 익명 세션이 없으면 마이그레이션 불필요 (이미 로그인 상태에서 사용 중이거나 마이그레이션 완료됨)
            return;
          }

          const sessionId = getAnonymousSessionId();
          const response = await fetch('/api/migrate-history', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ sessionId }),
          });

          if (response.ok) {
            const result = await response.json();
            setMigratedCount(result.migratedCount || 0);

            // 익명 세션 데이터 정리
            clearAnonymousSession();

            // 마이그레이션된 이력이 있을 때만 모달 표시
            if (result.migratedCount > 0) {
              setShowMigrationModal(true);
            }
          }
        } catch {
          // console.error('이력 마이그레이션 오류:', error);
        }
      };

      migrateHistory();
    }
  }, [isLoaded, isSignedIn, user, hasCheckedMigration]);

  return (
    <HistoryMigratedModal
      isOpen={showMigrationModal}
      onClose={() => setShowMigrationModal(false)}
      migratedCount={migratedCount}
    />
  );
}
